export default __webpack_public_path__ + "static/media/190629_190332_IMG_4549.26b6673a.jpg";